<template>
  <el-dialog title="新增会计年度" :visible.sync="visible" width="min(480px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <el-form ref="editForm" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="会计年度" prop="year">
        <el-input v-model="form.year" maxlength="4" placeholder="如 2026" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'

export default {
  name: 'PeriodAddOrUpdate',
  data() {
    return {
      visible: false,
      form: { year: '' },
      rules: {
        year: [
          { required: true, message: '会计年度不能为空', trigger: 'blur' },
          { pattern: /^\d{4}$/, message: '会计年度格式错误', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.visible = true
      this.form = { year: String(new Date().getFullYear()) }
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    onClosed() { this.form = { year: '' } },
    save() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        request.post('/finance/period/open', { year: this.form.year }).then(() => {
          this.$message.success('开账成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>
